module.exports = __webpack_public_path__ + "img/content_architecture_img.3acf6bb5.png";